<div class="service-appointment-details-container" [class.ready]="pageReady">
  @if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
  }

  @if (!loading && appointmentDetails) {
  <div class="details-header">
    @if(isCancelpage) {
     <div class="oab-header">
        <div class="page-header">Online Appointment Booking</div>
      </div>   
    <div class="cancel-heading" i18n>APPOINTMENT CANCELED</div>
    <div class="cancel-description" i18n>Your service appointment has been canceled.</div>
    <div class="service-heading" i18n>Service Appointment Details</div>
    }
    @else {
       <div class="oab-header">
        <div class="page-header">Online Appointment Booking</div>
      </div> 
    <div class="details-title" i18n>Service Appointment Details</div>
    }
  </div>

  <div [ngClass]="{ 'cancel-bg': isCancelpage }">
    <div class="details-content">
      <div class="detail-section-row">
        <div class="detail-label" i18n>Appointment No.</div>
        <div class="detail-content">
          <div class="detail-value" i18n>No.{{ appointmentDetails.documentNo || 'N/A' }}</div>
        </div>
      </div>

      <!-- Date and Time Section -->
      <div class="detail-section">
        <div class="detail-label" i18n>Date and time</div>
        <div class="detail-content">
          <div class="detail-value">{{ formatDate(appointmentDetails.appointmentDate) }}</div>
          <div class="detail-value">{{ formatTime(appointmentDetails.appointmentDate) }}</div>
          <div class="detail-subvalue">{{ appointmentDetails.serviceAdvisor.name }}</div>
        </div>
      </div>

      <!-- Vehicle Section -->
      <div class="detail-section">
        <div class="detail-label" i18n>Vehicle</div>
        <div class="detail-content">
          <div class="detail-value">{{ appointmentDetails.vehicle.make }} {{ appointmentDetails.vehicle.model }}</div>
          <div class="detail-subvalue">{{ getVehicleVin() }}</div>
          <div class="detail-subvalue">{{ appointmentDetails.vehicle.licenseNo }}</div>
        </div>
        @if (isCancelpage) {
        <span class="appointment-cancel-icon">
          <img src="assets/common/Cancel.png" alt="Confirmation Success" />
        </span>
        }
      </div>

      <!-- Service Centre Section -->
      <div class="detail-section">
        <div class="detail-label" i18n>Service Centre</div>
        <div class="detail-content">
          @if (locationDetails) {
          <div class="detail-value">{{ locationDetails.name }}</div>
          <div class="detail-subvalue">{{ locationDetails.company.name }}</div>
          @if (locationDetails.address) {
          <div class="detail-subvalue">{{ locationDetails.address.street }}, {{ locationDetails.address.city }}</div>
          }
          } @else {
          <div class="detail-value">{{ appointmentDetails.locationId || 'N/A' }}</div>
          <div class="detail-subvalue">N/A</div>
          <div class="detail-subvalue">N/A</div>
          }
        </div>
      </div>

      <!-- Services Section -->
      <div class="services-header">
        <div class="detail-label" i18n>Services</div>
      </div>

      @if (appointmentDetails.services && appointmentDetails.services.length > 0) {
      @for (service of appointmentDetails.services; track service.id) {
      <div class="service-row">
        <div class="service-details">
          <div class="service-name">{{ service.name }}</div>
        </div>
        <div class="service-price">
          @if (hasServicePrice(service)) {
          <span>
            {{ getServicePrice(service) |
            currency: service.unitPrice.currency : 'symbol' : '1.0-0' }}
          </span>
          <div class="price-note" i18n>
            {{ getServicePriceNote(service) }}
          </div>
          } @else {
          <span class="calculated-price" i18n>calculated at service center</span>
          }
        </div>
      </div>
      }
      } @else {
      <div class="service-row">
        <div class="service-name" i18n>No services selected</div>
        <div class="service-price">-</div>
      </div>
      }

    </div>
  </div>

  <div class="footer">
    @if(!isCancelpage) {
    <button mat-stroked-button color="primary" class="cancel-btn" i18n (click)="cancelAppointment()">
      {{ cancelAppointmentText }}
    </button>
    }
    @else
    {
    <button mat-flat-button class="cancel-btn" (click)="close()">
      {{ newAppointmentText }}
    </button>
    }
  </div>
  }

  @if (!loading && error && !appointmentDetails) {
  <div class="error-message">
    {{ error }}
  </div>
  }
</div>